import { faker } from '@faker-js/faker';

import type { InvestmentDetailsGetResponse } from '../types/InvestmentDetailsGetResponse';

export function createInvestmentDetailsGetResponse(
  data: NonNullable<Partial<InvestmentDetailsGetResponse>> = {}
): NonNullable<InvestmentDetailsGetResponse> {
  return {
    ...{
      data: {
        company: {
          current_share_class: faker.string.alpha(),
          expected_profit: faker.string.alpha(),
          investment_history: faker.helpers.arrayElements([
            {
              closing_balance: faker.number.float(),
              closing_shares: faker.number.int(),
              date: faker.string.alpha(),
              dividend_payments: faker.number.float(),
              investment_amount: faker.number.float(),
              opening_balance: faker.number.float(),
              price_per_share: faker.number.float(),
              share_class: faker.string.alpha(),
              share_purchases: faker.number.int(),
              updated_at: faker.string.alpha(),
            },
          ]) as any,
          monthly_investment_amount: faker.string.alpha(),
          monthly_investment_amount_remaining: faker.string.alpha(),
          portfolio_value: faker.string.alpha(),
          portfolio_value_progress_percentage: faker.number.float(),
          price_per_share_history: faker.helpers.arrayElements([
            { date: faker.string.alpha(), price_per_share: faker.number.float() },
          ]) as any,
          share_class_progress_percentage: faker.number.float(),
          show_gain_loss: faker.datatype.boolean(),
          show_top_up_account: faker.datatype.boolean(),
          subscription_form_link: faker.string.alpha(),
          title: faker.string.alpha(),
          total_gain_loss_amount: faker.string.alpha(),
          total_gain_loss_percentage: faker.number.float(),
          total_gain_loss_progress_percentage: faker.number.float(),
          total_investment: faker.string.alpha(),
        },
      },
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
